/**
 * Label — shared form label with a red required marker.
 *
 * Renders a red "*" after the text when `required` (the app-wide convention:
 * required fields are marked, optional ones are left unmarked). Callers may pass
 * an explicit `htmlFor` (to wire to a specific input id) and `className` to match
 * a page's label styling; both fall back to sensible defaults so existing
 * callers that pass only `label`/`required` keep working.
 */
export default function Label({ label, required, htmlFor, className }) {
  const derivedId = label ? label.split(" ").join("-").toLowerCase() : "";
  const forId = htmlFor ?? derivedId;
  const cls = className ?? "block text-sm font-normal text-gray-700";

  return (
    <label htmlFor={forId} className={cls}>
      {label}
      {required && (
        <span className="text-red-700"> *</span>
      )}
    </label>
  );
}
